<template>
<div>
  <h4 class="title is-4">
    {{ account.subscription.plan.title }}
    <span class="tag">{{ isAnnual ? 'Annual' : 'Monthly' }}</span>
  </h4>
</div>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  
  computed: {
    plan() {
      return this.account.subscription.plan
    },
    isAnnual() {
      return this.account.subscription.price_id === this.plan.annual_price_id
    },
    ...mapGetters('auth', [
      'account'
    ])
  }

}
</script>